export default new (class Helpful {
    constructor() {
        this.btnLike = 'helpful-like';
        this.btnDisLike = 'helpful-dislike';
        this.initHandler()
    }

    /**
     * @description Init handler.
     */
    initHandler() {
        document.addEventListener("DOMContentLoaded", () => {

            document.querySelectorAll(`.${this.btnLike}`).forEach((item) => {
                item.addEventListener('click', (e) => {
                    let _this = this;
                    let components = "ViolaArticleList";
                    if(item.closest('[data-components]')) {
                        components = item.closest('[data-components]').getAttribute('data-components');
                    }
                    oc.ajax(components+"::onHelpfulLikeSet", {
                        data: {
                            slug: item.getAttribute('data-slug'),
                            helpful: 1
                        },
                        success: function(...data) {
                            item.classList.add('active')
                            item.querySelector('span').textContent = data[0].like_count;

                            document.querySelectorAll(`.${_this.btnDisLike}`).forEach((item) => {
                                item.classList.add('pointer-events-none')
                            });
                            document.querySelectorAll(`.${_this.btnLike}`).forEach((item) => {
                                item.classList.add('pointer-events-none')
                            });
                        },
                    });
                });
            });

            document.querySelectorAll(`.${this.btnDisLike}`).forEach((item) => {
                item.addEventListener('click', (e) => {
                    let _this = this;
                    let components = "ViolaArticleList";
                    if(item.closest('[data-components]')) {
                        components = item.closest('[data-components]').getAttribute('data-components');
                    }
                    oc.ajax(components+"::onHelpfulLikeSet", {
                        data: {
                            slug: item.getAttribute('data-slug'),
                            helpful: 0
                        },
                        success: function() {
                            item.classList.add('active');

                            document.querySelectorAll(`.${_this.btnDisLike}`).forEach((item) => {
                                item.classList.add('pointer-events-none')
                            });
                            document.querySelectorAll(`.${_this.btnLike}`).forEach((item) => {
                                item.classList.add('pointer-events-none')
                            });
                        },
                    });
                });
            });

        });
    }
})()
